import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import Page from 'ui/page'
import { Button, ListGroup, Card, CardHeader, CardBody } from 'reactstrap'
import parse from 'react-html-parser'
import PubSub from 'pubsub-js'
import ApiFetcher from 'lib/api_fetcher'
import time from 'i18n/time'

const Bulletin = (props) => {
  const { records, urls } = props
  const { i18n } = useTranslation()

  const [response, setResponse] = useState()
  const [page, setPage] = useState(1)

  useEffect(() => {
    PubSub.publish('loading-page')

    new ApiFetcher({
      key: 'events',
      endpoint: urls.bulletin_grid,
      method: 'POST',
      body: JSON.stringify({ page })
    })
      .call()
      .then((res) => setResponse(res))
      .finally(() => PubSub.publish('loaded-page'))
  }, [page, urls])

  const BulletinItem = (props) => {
    const { title, excerpt, content, created_at } = props
    const [active, setActive] = useState(true)

    return (
      <Card className="mb-3">
        <CardHeader
          tag="div"
          className="d-flex justify-content-between align-items-center"
          style={{ cursor: 'pointer' }}
          onClick={() => setActive(!active)}
        >
          <h5 className="m-0">
            <a className="link-primary text-decoration-none">{title}</a>
          </h5>
          <div>
            <i>{time(created_at).format('LLLL')}</i>
          </div>
        </CardHeader>
        {active && (
          <CardBody>
            {parse(content)}
          </CardBody>
        )}
      </Card>
    )
  }

  return (
    <Page {...props}>
      <h1 className="mb-4">{i18n.t('bulletin.title')}</h1>
      {response && (
        <>
          <ListGroup className="mb-3">
            {response.records.map((i) => (
              <li key={i.id} className="list-group-item border-0 p-0">
                <BulletinItem {...i} />
              </li>
            ))}
          </ListGroup>

          <div className="d-flex justify-content-between align-items-center mt-3">
            <Button
              color="secondary"
              disabled={response.pagination.total_pages <= 1 || response.pagination.current_page <= 1}
              onClick={() => setPage((page) => page - 1)}
            >
              {i18n.t('format:pagination.newer')}
            </Button>
            <div>
              {i18n.t('format:pagination.page_of_total', {
                page: response.pagination.current_page,
                total: response.pagination.total_pages
              })}
            </div>
            <Button
              color="secondary"
              disabled={response.pagination.total_pages <= response.pagination.current_page}
              onClick={() => setPage((page) => page + 1)}
            >
              {i18n.t('format:pagination.older')}
            </Button>
          </div>
        </>
      )}
    </Page>
  )
}

export default Bulletin